import React from 'react';
import { Outlet } from 'react-router-dom';
import RFPSidebar from './RFPSidebar';
import RFPTopBar from './RFPTopBar';
import { useSidebar } from '../hooks';
import { getSidebarConfig } from '../utils';

const RFPLayout: React.FC = () => {
  const { isOpen: sidebarOpen, toggle: toggleSidebar } = useSidebar(true);

  // Get sidebar configuration (same as DashboardLayout)
  const sidebarConfig = getSidebarConfig('default');

  const handleSidebarLinkClick = (path: string) => {
    // Handle mobile sidebar closing on link click
    if (window.innerWidth <= 768) {
      console.log(`Navigating to: ${path}`);
    }
  };

  return (
    <div className="flex h-screen bg-[var(--color-bg-1)]">
      <RFPSidebar
        isOpen={sidebarOpen}
        onLinkClick={handleSidebarLinkClick}
        {...sidebarConfig}
      />
      <div className="flex-1 flex flex-col min-w-0 h-full">
        <RFPTopBar onToggleSidebar={toggleSidebar} />
        <main
          className="overflow-auto flex-1"
          data-scroll-container
          style={{
            scrollbarGutter: 'stable',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default RFPLayout;
